import * as React from "react";
import Tooltip from "@mui/material/Tooltip";
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Header from "../Includes/Header";
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useState } from "react";
import { useEffect, useRef } from "react";
import { DialogContentText } from "@mui/material";
import {
  Card,
  Button,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Paper,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Menu from "@mui/material/Menu";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import CircularProgress from "@mui/material/CircularProgress";
import json2mq from "json2mq";
import {
  retrieveAdminUser,
  AutocompleteAdminUser,
  DeleteAdminUser,
  StatusAdminUser,
  UpdateAdminUser,
} from "../Apihelper/ApiHelperUser";
import {
  RetriveOfferPackage,
  DeleteOfferpackageUser,
} from "../Apihelper/ApiOfferPackage";
import {
  UpdateOfferPackage,
  DeleteOfferpackage,
  AutocompleteOfferPackage,
} from "../Apihelper/ApiPackage";

import { useNavigate } from "react-router-dom";
import AppToast from '../../components/Toast/AppToast';

const useStyles = styled((theme) => ({
  tableContainer: {
    maxWidth: 600,
    margin: "0 auto",
  },
  table: {
    display: "none", // Hide the table on all screens
    [theme.breakpoints.down("sm")]: {
      display: "table", // Show the table on small screens only (mobile view)
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      display: "none", // Hide the card container on small screens (mobile view)
    },
  },
  card: {
    width: "100%",
    margin: "8px",
    padding: "16px",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "300px", // Adjust the card width as needed
    },
  },
}));
const drawerWidth = 292;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.875rem',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: '0.875rem',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#f8fafc',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#ffffff',
  },
  '&:hover': {
    backgroundColor: '#f1f5f9',
    transition: 'background-color 0.2s ease',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  minWidth: '32px',
  padding: '4px 8px',
}));

function OfferPackage(props) {
  const { colors: appColors } = useAppTheme();
  const navigate = useNavigate();
  const { window1 } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [status, setstatus] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [Role, setRole] = useState("");
  const [openToast, setOpenToast] = useState(false);
  const [options, setOptions] = useState([]);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [fetchdatarow, setetchdatarow] = useState([]); // Default to 'success'
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [localrole] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("userdata"))?.role || "";
    } catch {
      return "";
    }
  });
  const dateRef = useRef();
  const [age, setAge] = React.useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editedData, setEditedData] = useState({
    id: "",
    name: "",
    value: "",
    description: "",
    quantity: "",
    duration: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleEditModalOpen = (
    id,
    name,
    value,
    description,
    quantity,
    duration
  ) => {
    setEditedData({ id, name, value, description, quantity, duration });
    setEditModalOpen(true);
  };
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const handleChange = (event) => {
    const { name, value } = event.target;
    setEditedData((prevData) => ({
      ...prevData,
      [name]: value.toUpperCase(), // Convert all input values to uppercase
    }));
  };
  
  const mediaQueryVar = useMediaQuery(
    json2mq({
      minWidth: 600,
    })
  );
  React.useEffect(() => {
    const storedData = localStorage.getItem("userdata");
    if (!storedData) {
      // User is not logged in, no need to redirect
      navigate('/');
    }
    
  }, []);
  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

  const handleToastClose = () => {
    setOpenToast(false);
  };
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const container =
    window1 !== undefined ? () => window().document.body : undefined;

  // useEffect(() => {
  //   // Perform localStorage action
  //   const item = localStorage.getItem('userdata')
  //   if (item ==null){
  //      setredirectpage(true);
  //   }
  //   //console.log("tapan"+item);
  // }, [])
  // if (redirectpage) {

  //   return redirect('/');
  // }

  const handleConfirm = async () => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;

      const res = await StatusAdminUser(
        userToken,
        userId,
        status,
        deleteConfirmationId
      );

      if (res.code == "200") {
        handleSnackbarOpen(res.message, "success");
        setIsActive(!isActive);
        setOpenConfirmation(false);
        setOpenDeleteConfirmation(false);
        fetchData();
      } else {
        handleSnackbarOpen(res.message, "error");
        //  console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  const handleCancel = () => {
    setOpenConfirmation(false);
  };
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const fetchData = async (value = "") => {
    setLoading(true);
    setHasMore(true);
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id; // Assuming you have a userId in userdata
      const searchText = value; // Example search text
      const limit = 10; // Example limit
      const index = 0; // Example index
      const res = await RetriveOfferPackage(
        userToken,
        userId,
        searchText,
        limit,
        index
      );

      if (res.code == "200") {
        setetchdatarow(res.data);
        console.log(res.data);
        setLoading(false);
      } else {
        // console.error(error); // Handle error
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleLoadMore = async () => {
    // Calculate the next index based on the number of items loaded so far
    const nextIndex = fetchdatarow.length;

    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);

    try {
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const searchText = "";
      const limit = 10;

      const res = await RetriveOfferPackage(
        userToken,
        userId,
        searchText,
        limit,
        nextIndex
      );

      if (res.code == "200") {
        // Append the newly loaded data to the existing data
        setetchdatarow((prevResults) => [...prevResults, ...res.data]);

        // Check if there are more results available
        if (res.data.length >= 0 && res.data.length < 10) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSearchChange = (event, value) => {
    const searchText = value || ""; // If value is undefined or empty, set searchText to empty string
    // setSearchText(searchText);
    // Call fetchData function here with the updated searchText
    fetchData(searchText);
  };

  const handleDelete = (id) => {
    handleClose();
    setDeleteConfirmationId(id);
    setOpenDeleteConfirmation(true, id);
  };

  const handleConfirmDelete = async (id) => {
    // setSnackbarMessage('package deleted successfully');
    // setSnackbarSeverity('error');
    // setOpenDeleteConfirmation(false);
    // setOpenToast(true); // Show toast message

    if (deleteConfirmationId !== null) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id;

        const res = await DeleteOfferpackage(
          userToken,
          userId,
          deleteConfirmationId
        );

        if (res.code == "200") {
          handleSnackbarOpen(res.message, "success");
          setOpenDeleteConfirmation(false);
          fetchData();
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteConfirmation(false);
  };
  const handleInputChange = async (value) => {
    if (value.length >= 3) {
      try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text

        const res = await AutocompleteOfferPackage(
          userToken,
          userId,
          searchText
        );

        if (res.code == "200") {
          const names = res.data.map((item) => item.search_text);
          setOptions(names);
        } else {
          handleSnackbarOpen(res.message, "error");
          //  console.error(error); // Handle error
        }
      } catch (error) {
        console.error(error);
        // Handle errors
      }
    }
  };

  const handleEditModalClose = () => {
    setEditModalOpen(false);
  };

  const handleEditSubmit = async () => {
    // Check if required fields are filled
    if (
      !editedData.name ||
      !editedData.value ||
      !editedData.description ||
      !editedData.quantity ||
      !editedData.duration
    ) {
      setSubmitted(true);
      return;
    }

    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
    const userToken = userDataObj.token;

    try {
      const res = await UpdateOfferPackage(
        userToken,
        editedData // Pass the entire editedData object
      );

      if (res.code === 200) {
        handleSnackbarOpen(res.message, "success");
        setEditedData({
          id: "",
          name: "",
          value: "",
          description: "",
          quantity: "",
          duration: "",
        });
        fetchData();
      } else {
        handleSnackbarOpen(res.message, "error");
      }
    } catch (error) {
      console.error(error);
      handleSnackbarOpen("An error occurred while updating", "error");
    }

    setEditModalOpen(false);
  };

  return (
    <Box>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: { xs: 'column', sm: 'row' }, 
        justifyContent: 'space-between',
        alignItems: { xs: 'stretch', sm: 'center' },
        gap: 2,
        mb: 3
      }}>
        <Box flex={1} sx={{ width: { xs: '100%', sm: 'auto' } }}>
              <Autocomplete
                freeSolo
                disableClearable
                options={options}
            onInputChange={(event, value) => handleInputChange(value)}
                onChange={(event, value) => handleSearchChange(event, value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                label="Search packages"
                    size="small"
                    sx={{
                  width: '100%',
                  maxWidth: { sm: 300 },
                  backgroundColor: '#ffffff',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#e2e8f0',
                    },
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    },
                  },
                }}
                    InputProps={{
                      ...params.InputProps,
                  type: 'search',
                    }}
                  />
                )}
          />
        </Box>

        {localrole === 'admin' && (
        <Button
          variant="contained"
          startIcon={<ControlPointIcon />}
          onClick={() => navigate('/addofferpackage')}
                sx={{
            bgcolor: appColors.evergreen,
            '&:hover': {
              bgcolor: appColors.pine,
            },
            textTransform: 'none',
            fontWeight: 600,
            width: { xs: '100%', sm: 'auto' }
          }}
        >
          Add Package
        </Button>
        )}
            </Box>

      <Paper
        elevation={0}
              sx={{
          borderRadius: 2,
          overflow: { xs: 'auto', sm: 'hidden' },
          bgcolor: '#ffffff',
          boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
        }}
      >
        {loading ? (
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            p: 4 
          }}>
            <CircularProgress sx={{ color: appColors.evergreen }} />
          </Box>
        ) : (
          <TableContainer sx={{ 
            maxWidth: '100%',
            overflowX: 'auto'
          }}>
            <Table sx={{ 
              minWidth: { xs: 'auto', sm: 650 }
            }} size="medium">
              <TableHead>
                <TableRow>
                  <StyledTableCell sx={{ width: '50px' }}>#</StyledTableCell>
                  <StyledTableCell>Package Name</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Value</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>Description</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Quantity</StyledTableCell>
                  <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>Duration</StyledTableCell>
                  {localrole === 'admin' && (
                    <StyledTableCell align="right" sx={{ width: '100px' }}>Actions</StyledTableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {fetchdatarow.map((row, index) => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>
                      <Box>
                        <Typography variant="subtitle2" sx={{ color: appColors.evergreen, fontWeight: 600 }}>
                          {row.name}
                        </Typography>
                        <Typography 
                          variant="body2" 
                      sx={{
                            display: { xs: 'block', sm: 'none' },
                            color: '#64748b'
                          }}
                        >
                          ₹{row.value} • {row.quantity} qty
                        </Typography>
                      </Box>
                    </StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>₹{row.value}</StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{row.description}</StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.quantity}</StyledTableCell>
                    <StyledTableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.duration}</StyledTableCell>
                    {localrole === 'admin' && (
                    <StyledTableCell align="right">
                      <ButtonGroup
                        variant="outlined"
                        size="small"
                        sx={{
                          '& > button': {
                            borderColor: '#e2e8f0',
                          }
                        }}
                      >
                        <ActionButton
                          onClick={() => handleEditModalOpen(row.id, row.name, row.value, row.description, row.quantity, row.duration)}
                        sx={{
                            color: appColors.leaf,
                            '&:hover': {
                              bgcolor: '#eff6ff',
                              borderColor: appColors.leaf,
                            },
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </ActionButton>
                        <ActionButton
                          onClick={() => handleDelete(row.id)}
                        sx={{
                            color: '#dc2626',
                            '&:hover': {
                              bgcolor: '#fef2f2',
                              borderColor: '#dc2626',
                            },
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </ActionButton>
                      </ButtonGroup>
                    </StyledTableCell>
                    )}
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>

      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        mt: 3,
        mb: 3 
      }}>
        <Button
          variant="contained"
          onClick={handleLoadMore}
          disabled={!hasMore || (fetchdatarow.length < 10 && fetchdatarow.length !== 0)}
                        sx={{
            bgcolor: appColors.evergreen,
            '&:hover': {
              bgcolor: appColors.pine,
            },
            '&.Mui-disabled': {
              bgcolor: '#94a3b8',
              color: '#ffffff',
            },
            minWidth: '150px',
            height: '40px',
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          {fetchdatarow.length === 0 || fetchdatarow.length < 10 ? 'No More Records' : 'Load More'}
        </Button>
      </Box>

      <Dialog
        open={editModalOpen}
        onClose={handleEditModalClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ color: appColors.evergreen, fontWeight: 600 }}>
          Edit Package
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Package Name"
              name="name"
              value={editedData.name}
              onChange={handleChange}
              fullWidth
                        sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.evergreen,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.evergreen,
                  },
                },
              }}
            />
            <TextField
              label="Value"
              name="value"
              value={editedData.value}
              onChange={handleChange}
              fullWidth
                          sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.evergreen,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.evergreen,
                  },
                },
              }}
            />
            <TextField
              label="Description"
              name="description"
              value={editedData.description}
              onChange={handleChange}
              fullWidth
              multiline
              rows={3}
                          sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.evergreen,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.evergreen,
                  },
                },
              }}
            />
            <TextField
              label="Quantity"
              name="quantity"
              value={editedData.quantity}
              onChange={handleChange}
              fullWidth
                          sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.evergreen,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.evergreen,
                  },
                },
              }}
            />
            <TextField
              label="Duration"
              name="duration"
              value={editedData.duration}
              onChange={handleChange}
              fullWidth
                          sx={{
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e2e8f0',
                  },
                  '&:hover fieldset': {
                    borderColor: appColors.evergreen,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.evergreen,
                  },
                },
              }}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button
            onClick={handleEditModalClose}
                          sx={{
              color: '#64748b',
              '&:hover': {
                bgcolor: '#f1f5f9',
              },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
                          </Button>
          <Button
            onClick={handleEditSubmit}
            variant="contained"
                          sx={{
              bgcolor: appColors.evergreen,
              '&:hover': {
                bgcolor: appColors.pine,
              },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Save Changes
              </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteConfirmation}
        onClose={handleCancelDelete}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: '#dc2626', fontWeight: 600 }}>
          Delete Package
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this package?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button
            onClick={handleCancelDelete}
            sx={{
              color: '#64748b',
              '&:hover': {
                bgcolor: '#f1f5f9',
              },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            sx={{
              bgcolor: '#dc2626',
              '&:hover': {
                bgcolor: '#b91c1c',
              },
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </Box>
  );
}

export default OfferPackage;
